import * as z from "zod";

import { MunicipalPropertyType } from "@/graphql/generated/graphql";
import { MUNICIPAL_PROPERTY_MASTER_DATA_BOUNDS } from "@ark/shared";

interface CreateFormMessages {
  nameRequired: string;
  nameTooLong: string;
  floorAreaPositive: string;
  commissioningYearRange: string;
  effectiveYearRange: string;
}

interface BuildMunicipalPropertyCreateFormSchemaOptions {
  messages: CreateFormMessages;
  maxCommissioningYear: number;
}

const optionalText = (maxLength: number) => z.string().trim().max(maxLength);

export function buildMunicipalPropertyCreateFormSchema({
  messages,
  maxCommissioningYear,
}: BuildMunicipalPropertyCreateFormSchemaOptions) {
  return z.object({
    effectiveYear: z
      .number()
      .int(messages.effectiveYearRange)
      .min(MUNICIPAL_PROPERTY_MASTER_DATA_BOUNDS.minEffectiveYear, messages.effectiveYearRange)
      .max(MUNICIPAL_PROPERTY_MASTER_DATA_BOUNDS.maxEffectiveYear, messages.effectiveYearRange),
    name: z
      .string()
      .trim()
      .min(1, messages.nameRequired)
      .max(MUNICIPAL_PROPERTY_MASTER_DATA_BOUNDS.nameMaxLength, messages.nameTooLong),
    type: z.nativeEnum(MunicipalPropertyType),
    description: optionalText(MUNICIPAL_PROPERTY_MASTER_DATA_BOUNDS.descriptionMaxLength),
    street: optionalText(MUNICIPAL_PROPERTY_MASTER_DATA_BOUNDS.streetMaxLength),
    houseNumber: optionalText(MUNICIPAL_PROPERTY_MASTER_DATA_BOUNDS.houseNumberMaxLength),
    postalCode: optionalText(MUNICIPAL_PROPERTY_MASTER_DATA_BOUNDS.postalCodeMaxLength),
    city: optionalText(MUNICIPAL_PROPERTY_MASTER_DATA_BOUNDS.cityMaxLength),
    usableFloorAreaM2: z.number().finite().positive(messages.floorAreaPositive).nullable(),
    commissioningYear: z
      .number()
      .int(messages.commissioningYearRange)
      .min(MUNICIPAL_PROPERTY_MASTER_DATA_BOUNDS.minCommissioningYear, messages.commissioningYearRange)
      .max(maxCommissioningYear, messages.commissioningYearRange)
      .nullable(),
    municipalityIdList: z.array(z.string().min(1)).max(1),
  });
}
